<template>
  <div class="page">
    <app-title :page="'Red flags'">
      <div
        slot="content"
        class="flex justify-content-space-between flex-end">
        <p class="font-size-4 mb1">Need some examples to get you started? <a
          href="https://louderthanten.com/resources/red-flags"
          target="_blank">We&rsquo;ve got you covered</a>.</p>
      </div>
    </app-title>
    <section
      v-if="redFlags.length"
      class="grid">
      <div
        v-if="redFlags.length > 15"
        class="align-right"><router-link
          :class="'button accent large-button full-button_mb mt2 mb0'"
          :to="{ name: 'newRedFlag' }">New red flag</router-link></div>
      <div class="subtle px2 py1 my1">
        <lw-table
          :type="'lined'"
          :headings="[
            'Red flag',
            'Description'
          ]"
          :alignment="[
            'left',
            'left'
          ]"
          :widths="[
            '33',
            '67'
        ]">
          <tr
            v-for="(redFlag, index) in redFlags"
            :key="index">
            <td class="title">
              <router-link :to="{ name: 'redflag', params: { id: redFlag.id }}">{{ redFlag.title }}</router-link>
            </td>
            <td>
              <p>{{ truncate(redFlag.description, 140) }}</p>
            </td>
          </tr>
        </lw-table>
      </div>
      <div class="align-right"><router-link
        :class="'button accent large-button full-button_mb'"
        :to="{ name: 'newRedFlag' }">New red flag</router-link></div>
    </section>
    <section
      v-else
      class="grid">
      <div><router-link
        :class="'button accent large-button full-button_mb mt2'"
        :to="{ name: 'newRedFlag' }">Make your first red flag</router-link></div>
    </section>
    <transition
      name="slide-top"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Table from '../livewires/Table'
import { truncate } from '../mixins/truncate'
import page from '../mixins/page'

export default {
  components: {
    lwTable: Table
  },
  mixins: [
    truncate,
    page
  ],
  computed: {
    ...mapGetters({
      redFlags: 'redFlags'
    })
  },
  methods: {
    phaseName (id) {
      return this.skills[id].name
    }
  }
}
</script>
